<script>
  import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
  import {library as fontAwesomeIconLibrary} from '@fortawesome/fontawesome-svg-core'

  import camelCase from 'lodash/camelCase'

  // https://fontawesome.com/icons
  fontAwesomeIconLibrary.add(
    require('@fortawesome/free-solid-svg-icons/faSync').definition,
    require('@fortawesome/free-solid-svg-icons/faSun').definition,
    require('@fortawesome/free-solid-svg-icons/faAsterisk').definition,
    require('@fortawesome/free-solid-svg-icons/faUser').definition,
    require('@fortawesome/free-solid-svg-icons/faEnvelope').definition,
    require('@fortawesome/free-solid-svg-icons/faPhoneAlt').definition,
    require('@fortawesome/free-solid-svg-icons/faCheck').definition,
    require('@fortawesome/free-solid-svg-icons/faBan').definition,
    require('@fortawesome/free-solid-svg-icons/faCalendarAlt').definition,
    require('@fortawesome/free-solid-svg-icons/faCaretUp').definition,
    require('@fortawesome/free-solid-svg-icons/faCaretDown').definition,
    require('@fortawesome/free-solid-svg-icons/faCaretRight').definition,
    require('@fortawesome/free-solid-svg-icons/faCartPlus').definition,
    require('@fortawesome/free-solid-svg-icons/faInfo').definition,
    require('@fortawesome/free-solid-svg-icons/faBars').definition,
    require('@fortawesome/free-solid-svg-icons/faSearch').definition,
    require('@fortawesome/free-solid-svg-icons/faEdit').definition,
    require('@fortawesome/free-solid-svg-icons/faCheckDouble').definition,
    require('@fortawesome/free-solid-svg-icons/faTrash').definition,
    require('@fortawesome/free-solid-svg-icons/faPen').definition,
    require('@fortawesome/free-solid-svg-icons/faCog').definition,
    require('@fortawesome/free-solid-svg-icons/faPaperPlane').definition,
    require('@fortawesome/free-solid-svg-icons/faArrowLeft').definition,
    require('@fortawesome/free-solid-svg-icons/faArrowRight').definition,
    require('@fortawesome/free-solid-svg-icons/faPlus').definition,
    require('@fortawesome/free-solid-svg-icons/faUpload').definition,
    require('@fortawesome/free-solid-svg-icons/faDownload').definition,
    require('@fortawesome/free-solid-svg-icons/faTimes').definition,
    require('@fortawesome/free-solid-svg-icons/faEye').definition,
  )

  export default {
    components: {
      FontAwesomeIcon
    },
    inheritAttrs: false,
    props: {
      source: {
        type: String,
        default: 'font-awesome'
      },
      name: {
        type: [String, Array],
        required: true
      }
    },
    computed: {
      // Gets a CSS module class, e.g. iconCustomLogo
      customIconClass () {
        return this.$style[camelCase('icon-custom-' + this.name)]
      }
    }
  }
</script>

<template>
  <FontAwesomeIcon
    :icon="name"
    v-bind="$attrs"
    v-if="source === 'font-awesome'"
  />
  <span
    :class="customIconClass"
    v-bind="$attrs"
    v-else-if="source === 'custom'"
  ></span>
</template>
